var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 0C2.06928 0 2.66682 0.596778 2.66699 1.33301V21.333H22.667C23.4032 21.3332 24 21.9307 24 22.667C23.9998 23.4031 23.4031 23.9998 22.667 24H1.33301C0.64271 23.9998 0.0749848 23.4751 0.00683594 22.8027L0 22.667V1.33301C0.000175439 0.596886 0.596886 0.000175696 1.33301 0ZM23.1562 5.33301C23.6223 5.33324 24 5.71165 24 6.17773V12.4873C24 13.2394 23.0904 13.6158 22.5586 13.084L20.2881 10.8135L15.5068 15.4268C14.9903 15.9251 14.1718 15.9251 13.6553 15.4268L11.7754 13.6143L6.92578 18.293C6.39583 18.8042 5.55131 18.7887 5.04004 18.2588C4.52915 17.7289 4.54452 16.8852 5.07422 16.374L10.8496 10.8018C11.3662 10.3034 12.1846 10.3034 12.7012 10.8018L14.5811 12.6152L18.4023 8.92773L16.249 6.77441C15.7173 6.24265 16.0937 5.33314 16.8457 5.33301H23.1562Z",
    fill: "#1D252A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsUpIcon);
export default __webpack_public_path__ + "static/media/stats-up-icon.3c3abdc45f4c91f9fbd2e39f7f1c2d86.svg";
export { ForwardRef as ReactComponent };